import { render, staticRenderFns } from "./barterConttractProductDetail.vue?vue&type=template&id=37ddf168&scoped=true"
import script from "./barterConttractProductDetail.vue?vue&type=script&lang=js"
export * from "./barterConttractProductDetail.vue?vue&type=script&lang=js"
import style0 from "./barterConttractProductDetail.vue?vue&type=style&index=0&id=37ddf168&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ddf168",
  null
  
)

export default component.exports